module.exports = "<input type=\"text\" id=\"{{vm.inputId}}\" ng-model=\"vm.date\" ng-model-options=\"{debounce: 100}\" ng-change=\"vm.updateModelValue()\" placeholder=\"{{vm.placeholder}}\" class=\"form-control dvDatepicker\" ng-blur=\"vm.onBlur()\" ng-required=\"vm.dateRequired\" ng-disabled=\"vm.ngDisabled\"> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/directive/dv-datepicker/dv-datepicker.html
// module id = Zfe6
// module chunks = 0